var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m4 8c.628.836 1 1.874 1 3 0 .805-.192 1.564-.53 2.237a1 1 0 0 1-.087.234l-3.457 6.481C17.46 20.49 21 16.658 21 12a9 9 0 0 0-.514-3zM3.973 7.93A8.96 8.96 0 0 0 3 12c0 4.523 3.337 8.266 7.684 8.903l2.116-3.968q-.391.064-.8.065a5 5 0 0 1-4.316-2.477l-.021-.033zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0-6a8.98 8.98 0 0 0-6.775 3.078l2.198 3.907A5 5 0 0 1 12 7h7.483A8.99 8.99 0 0 0 12 3",
    clipRule: "evenodd"
  })));
};
export default Svg24;